export const HERO_TITLE = 'Every story has its cherries  pick yours.';
export const HERO_SUBTITLE = 'Your video, turned into a searchable spreadsheet of clips';
export const HERO_CTA = 'Start CherryPicking';

export const LEARNING_TITLE = 'Edit Less, Create More';
export const LEARNING_SUBTITLE = "Upload your video — we'll find the key quotes and emotional peaks, so you can focus on creating, not cutting.";
export const LEARNING_CTA = 'Start CherryPicking';

export const PRICING_TITLE = 'Pricing & Plans';
export const PRICING_SUBTITLE = 'Find your perfect plan';
export const PRICING_POPULAR_BADGE = 'Most Popular';
export const PRICING_ONE_TIME_PURCHASE = 'One time purchase';

export const NAV_PRODUCT = 'Product';
export const NAV_PRICING = 'Pricing';
export const NAV_ABOUT = 'About';
export const NAV_LOG_IN = 'Log In';
export const NAV_SIGN_UP = 'Sign Up';

export const FOOTER_TERMS = 'Terms';
export const FOOTER_PRIVACY = 'Privacy';

const landingText = {
  HERO_TITLE,
  HERO_SUBTITLE,
  HERO_CTA,
  LEARNING_TITLE,
  LEARNING_SUBTITLE,
  LEARNING_CTA,
  PRICING_TITLE,
  PRICING_SUBTITLE,
  PRICING_POPULAR_BADGE,
  PRICING_ONE_TIME_PURCHASE,
  NAV_PRODUCT,
  NAV_PRICING,
  NAV_ABOUT,
  NAV_LOG_IN,
  NAV_SIGN_UP,
  FOOTER_TERMS,
  FOOTER_PRIVACY,
};

export default landingText;
